/*
 * @Description: '首页'所有的路由
 * @LastEditors: Please set LastEditors
*/

export default [
    {
        path: '',
        component: resolve => require(['@/views/home'], resolve),
        name: 'Home',
        meta: {
            nav: '首页'
        }
    },
    {
        path: 'home',
        component: resolve => require(['@/views/home'], resolve),
        name: 'Home-2',
        meta: {
            nav: '首页'
        }
    }
      
]



// WEBPACK FOOTER //
// ./src/router/home.js